export const bitrixInstallPath = "/bitrix/install";

export default {
  path: bitrixInstallPath,
  name: "bitrix-install",
  meta: {
    layout: "empty",
    requiresAuth: false,
  },
  component: () => import("@/views/Bitrix/BitrixInstall"),
};
